import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text/Text";
import { ERPSyncStatus } from "src/core/orders/api/orders.api";

interface IProps {
  status?: ERPSyncStatus | null;
}

const StatusWrapper = styled(Text)<IProps>`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  color: ${({ theme }) => theme.colors.darkGrey};
  ${({ status }) => StatusCss(status)};
`;

const DefaultCss = css`
  color: inherit;
`;

const SucessCss = css`
  color: ${({ theme }) => theme.colors.success};
`;

const FailedCss = css`
  color: ${({ theme }) => theme.colors.error}
`;

// Gives the status the appropriate colour
const StatusCss = (status?: ERPSyncStatus | null) => {
  switch (status) {
    case ERPSyncStatus.UpToDate:
      return SucessCss;

    case ERPSyncStatus.ExportFailed:
    case ERPSyncStatus.ImportFailed:
      return FailedCss;
    default:
      return DefaultCss;
  }
};

export const erpSyncStatusTextSwitch = (status?: ERPSyncStatus | null): string => {
  switch (status) {
    case ERPSyncStatus.ExportFailed:
      return "Export failed";
    case ERPSyncStatus.ImportFailed:
      return "Import failed";
    case ERPSyncStatus.UpToDate:
      return "Up to date";
    case ERPSyncStatus.ImportPending:
    case ERPSyncStatus.ExportPending:
    case ERPSyncStatus.Updating:
      return "Updating";

    default:
      return "-";
  }
};

/**
 * Gets the credit status styled
 */
const ErpSyncStatusStyled: React.ReactFCWithChildren<IProps> = ({ status }) => {
  const statusText = React.useMemo(() => {
    return erpSyncStatusTextSwitch(status);
  }, [ status ]);

  return (
    <StatusWrapper status={status}>
      {statusText}
    </StatusWrapper>
  );
};

export default ErpSyncStatusStyled;
